const resetPasswordFormSelectors = {
  emailInput: "#RecoverEmail",
  form: "#recover_customer_password",
  formStatus: "#form-status--RecoverEmail",
};

class ResetPasswordForm {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
  }

  _getElements() {
    const form = document.querySelector(resetPasswordFormSelectors.form);
    return form
      ? {
        form,
        emailInput: form.querySelector(resetPasswordFormSelectors.emailInput),
      }
      : {};
  }

  _setupEventListeners() {
    this.elements.form.addEventListener("submit", this._handleFormSubmit);
  }

  _handleFormSubmit = (event) => {
    event.preventDefault();
    let formData = {};
    formData.email = this.elements.emailInput.value;

    fetch(truniagenMainApiBaseUrl + "/auth/reset-password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        email: formData.email,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.error || responseJson.errors) {
          this.elements.form.querySelector(resetPasswordFormSelectors.formStatus)?.remove();

          let formStatus = document.createElement("div");
          formStatus.id = "form-status--CustomerEmail";
          formStatus.classList.add("form-status");

          let errorMessages = []
          if (responseJson.error) {
            errorMessages.push(responseJson.error);
          } else if (responseJson.errors) {
            let fieldsNames = Object.keys(responseJson.errors)
            for (let i = 0; i < fieldsNames.length; i++) {
              let fieldErrors = responseJson.errors[fieldsNames[i]]
              for (let y = 0; y < fieldErrors.length; y++) {
                errorMessages.push(fieldErrors[y]);
              }
            }
          }

          let errorMessagesList = document.createElement("ul");
          for (let i = 0; i < errorMessages.length; i++) {
            let errorMessageListItem = document.createElement("li");
            errorMessageListItem.innerHTML = errorMessages[i];
            errorMessagesList.append(errorMessageListItem);
          }

          formStatus.innerHTML =
            '<div class="form-status__message form-status__message--error fs-body-75">'
            + errorMessagesList.innerHTML +
            '</div>';

          const form = this.elements.form;
          form.prepend(formStatus);
        } else {
          event.target.submit();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };
}

window.addEventListener("load", () => {
  typeof ResetPasswordForm !== "undefined" && new ResetPasswordForm();
});